import BaseComponent from "../baseComponent.js";
import styles from "./terms-and-conditions.scss";

export default class VerifyForgotPassword extends BaseComponent {
  constructor(props) {
    super(props);
  }

  componentDidMount() {
    this.$modal = $("#verify-forgot-password");
    this.$modal.modal({
      dismissible: false
    });
  }

  show() {
    // let email = " " + this.props.getUserEmail();
    // $(this.refs.email).text(email);
    this.$modal.modal("open");
  }

  hide() {
    this.$modal.modal("close");
  }

  render() {
    return (
      <div id="verify-forgot-password" className="modal" style={{maxHeight: "100%"}}>
        <div className="modal-content">
          <div className="header" style={{borderBottom: 0}}>
            <div className="title">Password reset</div>
            <div className="agree" style={{marginBottom: "18px"}}>We sent an email to
              <span ref="email" style={{color: "#336192"}}></span> to make
              sure you own it. Please check your email for the instructions on how to reset your password.
            </div>
          </div>
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/auth/verifyForgotPassword.jsx